import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { ResponseData } from '@/types/http';
import { COMMON_TYPE, CommonType } from '@/types/enums';
import { GeneralApi } from '@/apis';
import { BikeType, Manufacturer } from '@/types/generalSetting';
import { MyAccount } from '@/types/account';
import { GetOtherSettingResponse } from '@/types/http-payload/setting';

interface License {
    id: number,
    name: string,
    type: CommonType
}
export default class GeneralStore extends BaseStore {
    licenseTypeAll: License[] = [];
    licenseTypeGas: License[] = [];
    licenseTypeEk: License[] = [];
    bikeTypes: BikeType[] = [];
    bikeTypesEK: BikeType[] = [];
    manufacturers: Manufacturer[] = [];
    cancelSetting: any = null;
    otherSetting: GetOtherSettingResponse = {} as GetOtherSettingResponse;

    // list user: 1.admin, 2.Owner, 3.user
    usersByType: any[] = [];

    myAccount: MyAccount | undefined = undefined;

    api: GeneralApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            myAccount: observable,
            usersByType: observable,
            licenseTypeAll: observable,
            licenseTypeGas: observable,
            licenseTypeEk: observable,
            bikeTypes: observable,
            bikeTypesEK: observable,
            manufacturers: observable,
            cancelSetting: observable,
            otherSetting: observable,

            getLicenseGas: flow.bound,
            getLicenseEk: flow.bound,
            getLicenseAll: flow.bound,
            getPlaceAutoComplete: flow.bound,
            getMyAccount: flow.bound,
            getBikeTypes: flow.bound,
            editMyAccount: flow.bound,
            getManufacturers: flow.bound,
            getBikeTypesEK: flow.bound,
            registerCouponForeverEnduser: flow.bound,
            // gg map
            getLatLngFromPlaceId: flow.bound,
            // list user: 1.admin, 2.Owner, 3.user
            getUsersByType: flow.bound,
            getCancelSetting: flow.bound,
            getOtherSetting: flow.bound,
            // gg map
            getGgmapGeocodeByLatLng: flow.bound

        });
        this.api = new GeneralApi();
    }

    *getLicenseAll() {
        try {
            const payload = {
                key: 'licensetype',
                noUseToken: true
            };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGeneralSettings, payload);
            if (res?.ok) {
                this.licenseTypeAll = res.data;
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *getLicenseGas() {
        try {
            const payload = {
                key: 'licensetype',
                noUseToken: true
            };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGeneralSettings, payload);
            if (res?.ok) {
                const data = res.data;
                if (data?.length > 0) {
                    this.licenseTypeGas = data.filter(item => item.type === COMMON_TYPE.GAS);
                }
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    *getLicenseEk() {
        try {
            const payload = {
                key: 'licensetype',
                noUseToken: true
            };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGeneralSettings, payload);
            if (res?.ok) {
                const data = res.data;
                if (data?.length > 0) {
                    this.licenseTypeEk = data.filter(item => item.type === COMMON_TYPE.EK);
                }
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *getCancelSetting() {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getCancelSettings);
            if (res?.ok) {
                this.cancelSetting = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *getOtherSetting() {
        try {
            const res: ResponseData<GetOtherSettingResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getOtherSettings);
            if (res?.ok) {
                this.otherSetting = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *getPlaceAutoComplete(params) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getPlaceAutoComplete, params, { hideLoading: true });
            if (res?.ok) {
                return res.data;
            }
        } catch (error) {
        }
    }

    *getMyAccount() {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getMyAccount);
            if (res?.ok) {
                this.myAccount = res.data;
                return res;
            }
        } catch (error) {
        }
    }

    *editMyAccount(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.editMyAccount, payload);
            if (res?.ok) {
                return res;
            }
        } catch (error) {
        }
    }

    *getBikeTypes() {
        try {
            const payload = { key: 'biketype' };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGeneralSettings, payload);
            if (res?.ok) {
                this.bikeTypes = res.data;
                return res;
            }
        } catch (error) {
        }
    }

    *getBikeTypesEK() {
        try {
            const payload = { key: 'bikeEkType' };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGeneralSettings, payload);
            if (res?.ok) {
                this.bikeTypesEK = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *getManufacturers() {
        try {
            const payload = { key: 'manufacture' };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGeneralSettings, payload);
            if (res?.ok) {
                this.manufacturers = res.data;
                return res;
            }
        } catch (error) {
        }
    }

    // #region Register coupon forever enduser
    *registerCouponForeverEnduser(payload: { couponCode: string }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.registerCouponForeverEnduser, payload);
            if (res.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }
    // #endregion Register coupon forever enduser

    // #region Get Lat Lng from placeId
    *getLatLngFromPlaceId(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getLatLngFromPlaceId, payload);
            if (res.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }
    // #endregion Get Lat Lng from placeId

    *getUsersByType(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getUsersByType, payload);
            if (res?.ok) {
                this.usersByType = res.data;
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    // #region Google map geocode
    *getGgmapGeocodeByLatLng(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getGgmapGeocodeByLatLng, payload);
            if (res.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }
    // #endregion Google map geocode

    clean(): void {
        super.clean();

        this.myAccount = undefined;
        this.bikeTypes = [];
    }
}
